import Decimal from 'decimal.js';

export enum EstateEntitiesTableColumns {
  NAME = 'name',
  FEDERAL_ASSET_LOCATION = 'federalAssetLocationDisplay',
  STATE_ASSET_LOCATION = 'stateAssetLocationDisplay',
  VALUE = 'currentValue',
}

export interface EstateEntitiesTableRowData {
  id: string;
  entityId: string;
  name: string;
  entityTypeDescription: string;
  federalAssetLocationDisplay: string;
  stateAssetLocationDisplay: string;
  currentValue: Decimal;
  currentValueDisplay: string;
  valuationDateDisplay: string | undefined;
  onboardingSuggestionId: string | null;
}
